/**
 * Exponential backoff for use w/ fetching remote components.
 */
export async function retryWithExponentialBackoff<T>(
  promise: Promise<T>,
  maxRetires: number,
  baseDelayMs: number
): Promise<T> {
  let retries = 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    try {
      return await promise;
    } catch (error) {
      if (retries >= maxRetires) {
        console.error(`Failed resolution after ${retries} retries.`);
        throw error;
      }
      console.log(`Failed resolution. Initiating retry attempt: ${retries + 1}`);
      const delayMs = baseDelayMs * Math.pow(2, retries);
      await new Promise((resolve) => setTimeout(resolve, delayMs));
      retries++;
    }
  }
}

export const createScriptElement = (url: string): HTMLScriptElement => {
  const scriptElement = document.createElement("script");
  scriptElement.src = url;
  return scriptElement;
};
